<template>
    <li 
        class="dropdown-item dropdown--item" 
        :class="{ 'cursor-pointer': pointer, 'flex align-items-center': flex, 'disabled': disabled }" 
        v-bind="$attrs"
    >
        <slot />
    </li>
</template>

<script>
export default {
    name: "ListItem",
    
    props: {
        id: {
            type: String,
            default: "",
        },
        pointer: {
            type: Boolean,
            default: false,
        },
        flex: {
            type: Boolean,
            default: false,
        },
        disabled:{
            type: Boolean,
            default: false,
        },

    },
};
</script>